// 메뉴 구조 공유 컨텍스트 (2026-09-17 KST 추가)
//
// 사이드바와 상단 가로 메뉴바가 같은 메뉴 구조를 쓴다. 양쪽에서 useMenuStructure() 를
// 각각 부르면 훅 안의 useAppsAlert 가 두 벌 돌아간다. 이건 마운트 시 GraphQL 요청을
// 보낼 뿐 아니라 5분 주기 폴링 타이머까지 거는 훅이라, 그대로 두면 배경 요청이 계속
// 두 배로 나간다. 그래서 한 번만 계산해 컨텍스트로 나눠 준다.
import { createContext, type ReactNode, useContext } from "react";

import { useMenuStructure } from "./hooks/useMenuStructure";
import { type SidebarMenuItem } from "./types";

const MenuStructureContext = createContext<SidebarMenuItem[] | null>(null);

export const MenuStructureProvider = ({ children }: { children: ReactNode }) => {
  const menuStructure = useMenuStructure();

  return (
    <MenuStructureContext.Provider value={menuStructure}>{children}</MenuStructureContext.Provider>
  );
};

export const useMenuStructureContext = (): SidebarMenuItem[] => {
  const context = useContext(MenuStructureContext);

  if (context === null) {
    throw new Error("useMenuStructureContext must be used within a MenuStructureProvider");
  }

  return context;
};
